var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2319_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 -3.39188e-06C7.49344 -0.00387148 5.07774 0.938008 3.23536 2.6375C1.51862 4.21541 0.407252 6.34364 0.0934383 8.65416C-0.220375 10.9647 0.283098 13.3122 1.5168 15.2909C2.75049 17.2695 4.63685 18.7548 6.84967 19.49C9.06249 20.2251 11.4626 20.1639 13.6351 19.3169C15.8075 18.4698 17.6157 16.8903 18.7469 14.8513C19.8781 12.8123 20.2612 10.4421 19.83 8.15061C19.3987 5.85909 18.1803 3.7903 16.3853 2.30199C14.5903 0.813677 12.3317 -0.000589455 9.99995 -3.39188e-06ZM9.99995 18.3333C8.44645 18.3321 6.92421 17.8967 5.60505 17.0763C4.28589 16.2558 3.22235 15.0829 2.53445 13.69C1.84656 12.2971 1.56172 10.7397 1.71208 9.19345C1.86243 7.64725 2.442 6.17385 3.38536 4.93958L16.1333 15.6354C15.3538 16.4857 14.406 17.1646 13.3502 17.629C12.2943 18.0935 11.1534 18.3333 9.99995 18.3333ZM13.0291 10.8542L14.7104 8.925C14.9666 8.62916 14.7791 8.13333 14.4104 8.13333H10.7999C10.7873 8.13388 10.7747 8.13138 10.7632 8.12606C10.7518 8.12074 10.7417 8.11275 10.734 8.10275C10.7262 8.09276 10.721 8.08105 10.7187 8.0686C10.7164 8.05616 10.7171 8.04335 10.7208 8.03125L11.8749 4.82708C12.0437 4.35416 11.5083 3.9625 11.1895 4.32708L8.67495 7.20208L4.52911 3.72291C6.02703 2.42641 7.93783 1.70594 9.91885 1.69073C11.8999 1.67552 13.8215 2.36656 15.3392 3.63991C16.8568 4.91327 17.8712 6.68564 18.2003 8.63918C18.5295 10.5927 18.1519 12.5996 17.1354 14.3L13.0291 10.8542Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0291 9.08333L5.2916 11.0708C5.03327 11.3646 5.21869 11.8604 5.58744 11.8625L9.32077 11.875L8.14785 15.175C7.9791 15.65 8.5166 16.0375 8.83327 15.6729L11.3854 12.7417L7.0291 9.08333Z",
    fill: "#84B0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2319_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon-1.ac2c907d9306ad7fb713e4b939dc3aa5.svg";
export { ForwardRef as ReactComponent };